import { Sparkles, ChevronDown, Zap, Disc3, Check } from "lucide-react";
import { toast } from "sonner";
import { usePlayer } from "@/context/PlayerContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const LIGHT_STYLES = [
  { id: "laser", label: "Laser", desc: "Raggi colorati che ballano sul basso", Icon: Sparkles },
  { id: "strobo", label: "Strobo", desc: "Lampi bianchi sul beat, stile rave", Icon: Zap },
  { id: "club", label: "Club", desc: "Fari colorati morbidi, atmosfera lounge", Icon: Disc3 },
];

export const LightsButton = ({ testid = "lights-toggle-btn", withLabel = false }) => {
  const { lights, toggleLights, current, lightStyle, setLightStyle } = usePlayer();
  const style = LIGHT_STYLES.find((s) => s.id === lightStyle) || LIGHT_STYLES[0];
  const click = () => {
    toggleLights();
    if (!lights) toast(current ? `Luci ${style.label} accese: vanno a tempo con il brano!` : `Luci ${style.label} accese: fai partire un brano per farle ballare`);
  };
  const pick = (s) => {
    setLightStyle(s.id);
    if (!lights) toggleLights();
    toast(`Stile luci: ${s.label}`);
  };
  const on = "border-hot bg-hot/20 text-hot shadow-[0_0_24px_rgba(255,79,163,0.6)]";
  const off = "border-white/10 text-zinc-300 hover:text-hot hover:border-hot/60";
  return (
    <div className={`h-10 rounded-full border flex items-center transition-[color,border-color,box-shadow,background-color] duration-300 ${lights ? on : off}`}>
      <button onClick={click} aria-pressed={lights} aria-label={`Luci da discoteca (${style.label})`} data-testid={testid}
        className={`h-full ${withLabel ? "pl-4 pr-2" : "pl-3 pr-1"} flex items-center gap-2 text-xs font-bold`}>
        <style.Icon className="h-4 w-4" />{withLabel && <span>{lights ? `${style.label} ON` : "Luci"}</span>}
      </button>
      <DropdownMenu>
        <DropdownMenuTrigger className="h-full pr-2.5 pl-1 outline-none" aria-label="Scegli lo stile delle luci" data-testid={`${testid}-style-trigger`}>
          <ChevronDown className="h-3.5 w-3.5" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-[#1e2236] border-white/10 text-white w-64" data-testid={`${testid}-style-menu`}>
          <DropdownMenuLabel className="font-mono-tga text-[10px] uppercase tracking-[0.2em] text-zinc-400">Stile luci</DropdownMenuLabel>
          {LIGHT_STYLES.map((s) => (
            <DropdownMenuItem key={s.id} onSelect={() => pick(s)} className="gap-3 py-2 cursor-pointer focus:bg-white/10 focus:text-white" data-testid={`${testid}-style-${s.id}`}>
              <s.Icon className={`h-4 w-4 ${s.id === lightStyle ? "text-hot" : "text-zinc-400"}`} />
              <span className="flex-1"><b className="block text-sm">{s.label}</b><span className="text-[11px] text-zinc-400">{s.desc}</span></span>
              {s.id === lightStyle && <Check className="h-4 w-4 text-hot" />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
